import { render, staticRenderFns } from "./SpectrumChart.vue?vue&type=template&id=96e817dc&scoped=true&"
import script from "./SpectrumChart.vue?vue&type=script&lang=js&"
export * from "./SpectrumChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e817dc",
  null
  
)

export default component.exports